import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../../shared/components/button/Button";
import { ArrowUpDown } from "lucide-react";
import { resolveClientAdministrationById } from "../../../../../shared/lib/routesResolver";
import { DataTable } from "../../../../../shared/components/data-table/DataTable";
import ActiveBadge from "../../../../../shared/components/badge/ActiveBadge";
import TableDeleteButton from "../../../../../shared/components/button/TableDeleteButton";
import UpdateClientDialog from "./update/UpdateClientDialog";

const ClientsAdministrationTable = ({ data, onDelete, onEdit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns = [
    {
      accessorKey: "logoPath",
      header: "",
      cell: ({ row }) => (
        <div className="hidden sm:table-cell">
          <img
            alt="client logo"
            className="aspect-square rounded-md object-fit"
            height={32}
            src={row.getValue("logoPath")}
            width={32}
          />
        </div>
      ),
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t("clients.overview.table.header.name")}
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="font-medium">
            <Link
              to={resolveClientAdministrationById(data.id)}
              className="underline"
              state={{ id: data.id }}
            >
              {row.getValue("name")}
            </Link>
          </div>
        );
      },
    },
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <Button
            variant="ghost"
            onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          >
            {t("clients.overview.table.header.code")}
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        );
      },
      cell: ({ row }) => (
        <div className="font-medium">{row.getValue("code")}</div>
      ),
    },
    {
      accessorKey: "enabled",
      header: "Status",
      cell: ({ row }) => <ActiveBadge booleanValue={row.getValue("enabled")} />,
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdateClientDialog
              client={data}
              onSubmitHandler={(formValues) => onEdit(data.id, formValues)}
            />
            <TableDeleteButton onClickHandler={() => onDelete(data.id)} />
          </div>
        );
      },
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default ClientsAdministrationTable;
